<template>
	<div class="stage stage--systeemdenken-controle" v-if="state == 'question'">
	
		<div class="content-container">
			
			<div class="header__container">
				<div class="header">
					{{roundData.header}}
				</div>
				<div class="subHeader">
					{{roundData.subheader}}
				</div>
			</div>

			<div class="btn__explanation" @click="showExplanationPopup">
				<i class="fa fa-question"></i>
			</div>


			<div class="systeem-container shadow-box shadow-box-systeemdenken">

				<img
					v-if="questionData.visual !== undefined && questionData.visual !== null && questionData.visual !== ''"
					:src="baseUrl + questionData.visual"
					class="systeem__image"
				>

				<div class="systeem" v-else>
					<div class="systeem-canvas">
						<div class="canvas-container">

						</div>
					</div>
					<div class="systeem-ui">

						<div
							v-for="(item,index) in items"
							v-if="usedPositions.length > index"
							:key="index"
							class="systeem-item"
							:style="{left:usedPositions[index].x+'%',top:usedPositions[index].y+'%'}"
						>
							<img
								v-if="item.icon !== undefined && item.icon !== null"
								:src="item.icon"
								class="systeem-item-icon"
							>
							<div class="item__content">
								{{item.name}}
							</div>
						</div>
					</div>
				</div>

			</div>

			<div class="question_text" style="position: relative; margin-top: 30px; text-align: center">
				{{questionData.questiontext}}
			</div>

			<div class="systeem-controls">

				<div
					v-for="(answer,index) in questionData.answers"
					:key="index"
					:index="index"
					class="btn btn-progres systeemdenken_multiquiz__button"
					style="margin-top: 10px"
					@click="()=>{onAnswer(index);}"
				>
					{{answer.answer}}
				</div>

			</div>

			<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:additionalHTML="additionalHTML"
			:on-click="hideExplanationPopup"/>

		</div>

	</div>
	<div class="stage stage--systeemdenken-controle-feedback" v-else>
		<div class="header__container">
			<div class="header">
				{{roundData.header}}
			</div>
			<div class="subHeader">
				{{roundData.subheader}}
			</div>
			

			<div class="text">
				{{feedbackText}}
			</div>
		</div>
	</div>
</template>

<script>
import Score from "../../Score.vue";
import { url } from "../../../const/base";
import { mapGetters, mapActions } from "vuex";
import ExplanationPopup from '../ExplanationPopup.vue';

export default {
	components: {
		Score,
		ExplanationPopup
	},

	data() {
		return {
			baseUrl: url,
			explanationPopupActive: false,
			usedPositions: [],
			positions: [
				[{ x: 50, y: 10 }, { x: 50, y: 95 }],
				[{ x: 50, y: 10 }, { x: 80, y: 75 }, { x: 20, y: 75 }],
				[
					{ x: 50, y: 10 },
					{ x: 90, y: 50 },
					{ x: 50, y: 90 },
					{ x: 10, y: 50 }
				],
				[
					{ x: 50, y: 10 },
					{ x: 230, y: 100 },
					{ x: 185, y: 210 },
					{ x: 55, y: 210 },
					{ x: 10, y: 100 }
				],
				[
					{ x: 70, y: 10 },
					{ x: 90, y: 50 },
					{ x: 70, y: 90 },
					{ x: 30, y: 90 },
					{ x: 10, y: 50 },
					{ x: 30, y: 10 }
				]
			],
			arrows: [],
			score: 0,
			answers: [],
			state: "question",
			feedbackText: "",
			additionalHTML:"",
		};
	},

	beforeMount() {
		this.clear();
		this.buildInfoAddonHTML();
	},

	computed: {
		...mapGetters([
			"lastQuestion",
			"currentQuestion",
			"questionData",
			"roundData",
			"questionCount"
		]),

		items() {
			if (typeof this.questionData.items === "undefined") {
				this.questionData.items = [];
			}
			return this.questionData.items;
		}
	},

	watch: {
		currentQuestion: function(val) {
			this.clear();
		}
	},

	mounted() {
		this.showTransitorScore(true);

		console.log(this.items.length);
		if (this.items.length) {
			this.drawArrowCanvas();
		}
	},

	methods: {
		...mapActions([
			"showTransitorScore",
			"increaseTransitorScore",
			"completeRound",
			"toNextQuestion",
			"setRoundScore",
			"logAnswers",
			"hideNextButton",
			"showNextButton",
			"setNextButtonAction"
		]),

		hideExplanationPopup(){
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},

		showExplanationPopup(){
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},


		buildInfoAddonHTML(){

			// this.additionalHTML = '<div class="info">'+this.questionData.info+'</div>';

			// this.additionalHTML += '<div class="item_info">';

			// for (let i = 0; i < this.questionData.answers.length; i++) {
				
			// 	this.additionalHTML += '<div class="item">';
			// 	this.additionalHTML += '<div class="item-header">'+this.questionData.answers[i].answer+'</div>';
			// 	this.additionalHTML += '<div class="item-text">'+this.questionData.answers[i].info+'</div>';
			// 	this.additionalHTML += '</div>';

			// }
			// this.additionalHTML += '</div>';


			this.additionalHTML = this.roundData.rules;			
		},

		drawArrowCanvas() {
			if (this.items.length < 1) {
				return false;
			}

			let itemSpeed = 0;
			let arrowSpeed = 0;
			let positions = this.positions[this.items.length - 2];
			this.usedPositions = [];
			for (let i = 0; i < positions.length; i++) {
				setTimeout(() => {
					this.usedPositions.push(positions[i]);
				}, i * itemSpeed);
				//this.usedPositions = this.positions[this.items.length-2];
			}

			for (let i = 0; i < this.questionData.arrows.length; i++) {
				setTimeout(() => {
					let arrow = this.questionData.arrows[i];
					this.drawArrow(
						+arrow.from,
						+arrow.to,
						arrow.increase === "True"
					);
				}, i * arrowSpeed + this.items.length * itemSpeed);
			}
		},

		onAnswer(index) {
			this.answers.push(index);
			if (index == +this.questionData.correct_answer - 1) {
				this.feedbackText = this.questionData.question_feedback.correct;
				this.increaseTransitorScore(
					+this.roundData.transitor_multiplier
				);
				this.score++;
			} else {
				this.feedbackText = this.questionData.question_feedback.incorrect;
			}

			this.setRoundScore(this.score / this.questionCount * 100).then(
				() => {
					this.logAnswers(this.answers).then(() => {
						this.clear();
						this.toFeedback();
					});
				}
			);
		},

		toFeedback() {
			this.state = "feedback";

			setTimeout(() => {
				this.setNextButtonAction(() => {
					if (this.lastQuestion) {
						this.completeRound();
					} else {
						this.toNextQuestion().then(() => {
							this.state = "question";
							this.buildInfoAddonHTML();
							this.drawArrowCanvas();
						});
					}
				}).then(() => {
					this.showNextButton();
				});
			}, 500);
		},

		onClickItem(event, index) {
			if (this.deleting) {
				this.removeArrow(this.from, index);
				this.deleting = false;
				this.from = -1;
			} else {
				if (this.from == -1) {
					this.from = index;
				} else if (this.from == index) {
					this.from = -1;
				} else {
					let tempFrom = this.from;
					this.from = -1;

					if (this.drawArrow(tempFrom, index, this.increase)) {
						if (this.increase) this.increaseCount--;
						else this.decreaseCount--;
						this.answers.push({
							from: tempFrom,
							to: index,
							type: this.increase ? "increase" : "decrease"
						});

						if (
							this.increaseCount == 0 &&
							this.decreaseCount == 0
						) {
							this.setNextButtonAction(
								this.completeQuestion
							).then(() => {
								this.showNextButton();
							});
						}
					}
				}
			}
		},

		completeQuestion() {
			this.increaseTransitorScore(10).then(() => {
				if (this.lastQuestion) this.completeRound();
				else this.toNextQuestion();
			});
		},

		clear() {
			this.removeArrows();
		},

		removeArrows() {
			for (let arrow of this.arrows) {
				if (arrow != null) {
					arrow.remove();
				}
			}
			this.arrows = [];
		},

		drawArrow(from, to, increase) {
			let id = "canvas_" + from + "_" + to;
			let w = parseInt($(".canvas-container").width());
			let h = parseInt($(".canvas-container").height());

			let arrowColor = increase ? "#e76740" : "#3abbd6";
			$("<canvas>")
				.attr({
					id: id,
					width: w,
					height: h,
					class: "arrow-canvas",
					datatype: increase ? "increase" : "decrease"
				})
				.appendTo(".canvas-container");

			let canvas = $("#" + id);
			this.arrows.push(canvas);
			let context = canvas[0].getContext("2d");

			const items = $(".systeem-ui").find(".systeem-item");

			let startPos = this.usedPositions[from];
			let endPos = this.usedPositions[to];

			items.each(function(i) {
				if (i === from) startPos = $(this).position();
				if (i === to) endPos = $(this).position();
			});

			this.drawArrowContext(
				context,
				startPos.left,
				startPos.top,
				endPos.left,
				endPos.top,
				arrowColor
			);
			return true;
		},

		drawArrowContext(ctx, fromx, fromy, tox, toy, color) {
			let headlen = 5;
			let angle = Math.atan2(toy - fromy, tox - fromx);
			//starting path of the arrow from the start square to the end square and drawing the stroke

			let distance = Math.hypot(tox - fromx, toy - fromy);
			let degrees = this.calculateAngle(fromx, fromy, tox, toy);

			let fromPos = this.translateCoords(
				tox,
				toy,
				degrees - 180,
				distance - 35
			);
			let toPos = this.translateCoords(
				fromx,
				fromy,
				degrees,
				distance - 40
			);

			fromPos = this.translateCoords(
				fromPos.x,
				fromPos.y,
				degrees + 90,
				6
			);
			toPos = this.translateCoords(toPos.x, toPos.y, degrees + 90, 6);

			//console.log(fromPos);

			let arrowPointLeft = {
				x: toPos.x - headlen * 2 * Math.cos(angle - Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle - Math.PI / 7)
			};

			let arrowPointRight = {
				x: toPos.x - headlen * 2 * Math.cos(angle + Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle + Math.PI / 7)
			};

			let tip = {
				x: toPos.x,
				y: toPos.y
			};

			ctx.beginPath();
			ctx.moveTo(fromPos.x, fromPos.y);
			ctx.lineTo(toPos.x, toPos.y);
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();

			//starting a new path from the head of the arrow to one of the sides of the point
			ctx.beginPath();
			ctx.moveTo(toPos.x, toPos.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);
			ctx.lineTo(arrowPointRight.x, arrowPointRight.y);
			ctx.lineTo(tip.x, tip.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);

			//draws the paths created above
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();
			ctx.fillStyle = color;
			ctx.fill();
		},

		calculateAngle(cx, cy, ex, ey) {
			let dy = ey - cy;
			let dx = ex - cx;
			let theta = Math.atan2(dy, dx); // range (-PI, PI]
			theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
			if (theta < 0) theta = 360 + theta; // range [0, 360)
			return theta;
		},

		translateCoords(xCoord, yCoord, angle, length) {
			length = typeof length !== "undefined" ? length : 10;
			angle = angle * Math.PI / 180; // if you're using degrees instead of radians
			return {
				x: length * Math.cos(angle) + xCoord,
				y: length * Math.sin(angle) + yCoord
			};
		}
	}
};
</script>

<style>
.arrow-canvas {
	position: absolute;
	top: 0px;
	left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/minigames/SysteemdenkenControleVragen/Index.vue